/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.success\":[\"Sirkel med sjekkmerke\"]}");